import { ShieldCheck } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";

const TOOLTIP_TEXT = {
  user: "Encrypted — only visible to you",
  shared: "Encrypted — only visible to you and your coaches",
  coach: "Encrypted — shared by the client",
} as const;

export function EncryptionBadge({
  variant = "user",
}: {
  variant?: "user" | "shared" | "coach";
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">
          <ShieldCheck className="size-4 text-blue-500" />
        </span>
      </TooltipTrigger>
      <TooltipContent>{TOOLTIP_TEXT[variant]}</TooltipContent>
    </Tooltip>
  );
}
